// extracted by mini-css-extract-plugin
module.exports = {"Issues":"ComponentBodyMagazineIssueList_Issues__Mmz46","Links":"ComponentBodyMagazineIssueList_Links__7P72i"};